import Swal from 'sweetalert2';
import mountVues from '@galaxy/modules/Core/resources/js/mountVues';

common.View.create('crud::form.dataset.ItemsWithFooter', {

	onDOMLoad()
	{
		this.initGui();
		this.initSorting();
		this.updateIndices();
		this.updateNone();
	},

	initGui()
	{
		this.element

			// Listen for delete button click.
			.find('button[name="delete"]')
				.click(this.onButtonDeleteClick.bind(this))
				.end()

			// Listen for add button click.
			.find('button[name="add"]')
				.click(this.onButtonAddClick.bind(this))
				.end()

		/*
		.find('.card-title')
			.click(this.onTitleClick)
			.end();
		*/

		this.updateAddButton();
	},

	initSorting()
	{
		// Get items element.
		var itemsElement = this.element.find('.dataset-items').get(0);

		// Init sortable items.
		window.sortable(itemsElement, {
			items: '.dataset-item:not(.new)',
			handle: 'button[name="sort"]',
			forcePlaceholderSize: true,
			placeholder: this.buildSortingPlaceholder(),
		});

		// Update indices once sorting is stopped.
		itemsElement.addEventListener('sortstop', this.updateIndices.bind(this));
	},

	reinitSorting()
	{
		// Reinit - options are preserved.
		window.sortable(this.element.find('.dataset-items').get(0));
	},

	buildSortingPlaceholder()
	{
		// Get html of .dataset-items.new without content.
		return this.element

			.find('.dataset-item.new')
			.clone()
			.removeClass('hidden new')
			.html(this.getType() === 'table' ? '<td></td>' : '')
			.wrap('<div />')
			.parent()
			.html();
	},

	async onButtonDeleteClick(event)
	{
		// Confirm
		const {value: confirmed} = await Swal.fire({
			title: 'Weet u het zeker?',
			text: 'Weet u zeker dat u deze wenst te verwijderen?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#f87171',
			confirmButtonText: 'Ja, verwijder',
			cancelButtonText: 'Annuleer',
		});

		// Is confirmed?
		if (confirmed)
			this.deleteItem($(event.currentTarget).closest('.dataset-item'));
	},

	onButtonAddClick()
	{
		// Get template.
		let template = this.element.find('.dataset-item.new noscript[data-new]').text();

		// TODO Why needed sometimes and sometimes not?
		// Remove script wrapper?
		if (template.startsWith('<script type="text/html">'))
			template = template.substr('<script type="text/html">'.length, template.length - '</script>'.length);

		// Get new template.
		let newRow = this.element

            // Find new item.
            .find('.dataset-item.new')

            // Clone
            .clone(true, true)
            .removeClass('hidden new')

            // Hide
            .css({
                display: 'none',
                opacity: 0
            })

            // Init fields.
            .find('noscript[data-new]')
            .replaceWith(template)
            .end()

            // Append to items.
            .appendTo(this.element.find('.dataset-items'));

        this.initRowWithTemplate(newRow);

        // Add row to items.
        newRow.appendTo(this.element.find('.dataset-items'));

        mountVues(newRow);

		newRow.attr('data-iteration', this.element.find('.dataset-item:not(.new)').length)

        this.updateIndices();
        this.updateAddButton();
        this.reinitSorting();
        this.updateNone();

        // Emit
        this.element.trigger('crud::form-dataset:add');

        // Initialize inner views.
        common.View.reinit();

        // Show
        setTimeout(() => {

            // Animate in.
            newRow.slideDown('fast')
                .animate({opacity: 1}, 'fast');

            // Focus first input (if found)
            $(this.element.find('.dataset-items > :last-child input:not([type="hidden"])').get(0)).focus();

        }, 1);
    },

    initRowWithTemplate(newRow)
    {
        // Get template.
        let template = this.element.find('.dataset-item.new noscript[data-new]').text();

        // TODO Why needed sometimes and sometimes not?
        // Remove script wrapper?
        if (template.startsWith('<script type="text/html">'))
            template = template.substr('<script type="text/html">'.length, template.length - '</script>'.length);

        // Table?
        if (this.getType() === 'table')
            newRow

                // Replace
                .find('.newPlaceholder')
                .replaceWith(template)
                .end();

        // Card?
        else
            newRow

                // Init fields.
                .find('noscript[data-new]')
                .replaceWith(template)
                .end();
	},

	getType()
	{
		return this.element.find('.crud\\:\\:form-dataset-table-Items').length === 1 ? 'table' : 'card';
	},

	updateAddButton()
	{
		// Abort due to max amount of items is not limited?
		let maxItemsAmount = this.element.find('.dataset-items').data('max-items-amount');

		if (!maxItemsAmount)
			return;

		// Determine amount of items.
		let disabled = this.element.find('.dataset-item:not(.new)').length >= maxItemsAmount;

		this.element

			// Update add button.
			.find('button[name="add"]')
				.prop('disabled', disabled)
				.attr('disabled', disabled)
				.css('pointer-events', disabled ? 'none' : 'auto')

				.parent()

				// (Un)set tooltip data.
				.attr({
					'title': disabled ? 'Het maximum aantal van ' + maxItemsAmount + ' is reeds bereikt.' : '',
					'class': disabled ? 'opacity-50 cursor-disabled' : '',
				})

				.end()

			.end();
	},

	deleteItem(itemElement)
	{
		itemElement

			// Disable interaction.
			.css('pointer-events', 'none')

            // Remove input names already (so they won't get send if animation is not done yet)
            .find('input, select, textarea')
                .attr('name', '')
                .end()

			// Hide with animation.
			.animate({opacity: 0}, 'fast')
			.slideUp('fast', () =>
			{
				// Remove
				itemElement.remove();

				// Update
				this.updateIndices();
				this.updateAddButton();
				this.updateNone();

				this.element.trigger('crud::form-dataset:delete');
			});
	},

	updateIndices()
	{
		this.element

			// Loop items.
			.find('.dataset-item:not(.new)')
			.each((index, element) => this.updateIndicesItem($(element), index))
			.end();

		this.element.trigger('crud::form-dataset:sorted');
	},

	updateIndicesItem(itemElement, itemIndex)
	{
		itemElement

			// Update iteration.
			.find('.iteration:first')
			.text(itemIndex + 1)
			.end()

			// Process all basic inputs.
			.find('input, select, textarea')
			.filter('[name]')
			.each((index, element) => this.updateIndicesInput(itemElement, $(element), itemIndex))
			.end()
			.end()

			// Process each VSelect.
			.find('.crud\\:\\:form-inputs-VSelectComponent')
			.each((index, element) => this.updateIndicesVSelect(itemElement, element, itemIndex))
			.end();
	},

	updateIndicesInput(itemElement, inputElement, itemIndex)
	{
        let newItemInputName = this.getItemInputName(itemElement, itemIndex, inputElement.attr('name'));

        // Set (new) name.
		inputElement.attr('name', newItemInputName);

        // Set name on dusk selector
        $(inputElement).parents('[class*="crud::form-inputs"]').attr('dusk', this.slugify(newItemInputName));
	},

    slugify(str) {
        str = str.replace(/^\s+|\s+$/g, '');

        // Make the string lowercase
        str = str.toLowerCase();

        // Remove dirs?
        if (!this.element.find('input').data('allow-dir')) {
            str = str.replace(/\//g, '-');
        }

        // Remove accents, swap ñ for n, etc
        let from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
        let to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa-/----";

        for (let i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        // Remove invalid chars
        str = str.replace(/[^\w-\/ ]+/g, '')
            // Collapse whitespace and replace by -
            .replace(/\s+/g, '-')
            // Collapse dashes
            .replace(/-+/g, '-')
            // Replace multiple slashes
            .replace(/[/_,]+/g, '/')
            // And replace first and last slash with nothing
            .replace(/^\//g, '');

        return str;
    },

	updateIndicesVSelect(itemElement, inputElement, itemIndex)
	{
		// @ugly Supress prop change warning. The parent wont update the component; the parent is the general window.vueApp which does not know about this VSelect.
		Vue.config.silent = true;

		// Set (new) name.
		inputElement.__vue__.name = this.getItemInputName(itemElement, itemIndex, inputElement.__vue__.name);

		Vue.config.silent = false;
	},

	getItemInputName(itemElement, itemIndex, postfixName)
	{
		// Abort due to is internal __dataset item?
		if (postfixName.startsWith('__dataset['))
			return;

		// Loose dataset name + "[".
		let datasetName = itemElement.data('name');

		postfixName = postfixName.substr(datasetName.length + 1);

		// Get current index.
		let currentIndex = postfixName.split(']')[0];

		// Loose index + "]".
		postfixName = postfixName.substr((currentIndex + '').length + 1);

		// Return (new)) name.
		return datasetName + '[' + itemIndex + ']' + postfixName;
	},

	updateNone()
	{
		this.element

			// Show / hide none based on amount of items?
			.find('.none')
			.toggleClass('hidden', this.element.find('tbody .dataset-item:not(.none):not(.new)').length > 0)
			.end();
	},
});
